export default __webpack_public_path__ + "static/media/highlights.d9a7fa8b.svg";